export interface NavigationBar {
  name: "Anzeigen" | "Nachrichten" | "Archiv" | "Einstellungen",
  value: NavigationBarItem,
  current: boolean
}

export enum NavigationBarItem {
  MESSAGES = 'messages',
  ENTRIES = 'entries',
  ARCHIVE = 'archive',
  SETTINGS = 'settings',
  FAVORITES = 'favorites',
}

